"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions = {
    SET_STATE: 'workfront/SET_STATE',
    LOAD_STATE: 'workfront/LOAD_STATE',
    GET_STATE: 'workfront/GET_STATE',
    SET_PARAMETERS: 'workfront/SET_PARAMETERS',
};
exports.default = actions;
//# sourceMappingURL=actions.js.map